<template>
  <div class="page-main">
    <div class="hd-bg"></div>
    <pageHeader />
    <router-view></router-view>
  </div>
</template>
<script>
import pageHeader from "@/comps/header";

export default {
  components: {
    pageHeader,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="less" src="./assets/css/reset.less"></style>
<style lang="less" src="./assets/css/main.less"></style>
